import classNames from "classnames";
import { ORGANIZATIONS, QUESTION_TYPE } from "constant";
import { useMemo } from "react";
import { storage } from "services/storage";

export const QuizHeader = ({ sectionName, questionOrder, children, type, isMcq = false }) => {
  const organization = storage.get.org();
  const spotlightOrgFlag = organization === ORGANIZATIONS.SPOTLIGHT

  const isSpeech = useMemo(
    () =>
      [
        QUESTION_TYPE.SPEECH_SCRIPTED,
        QUESTION_TYPE.SPEECH_SPONTANEOUS,
      ].includes(type),
    [type]
  );

  const isBreaker = useMemo(
    () =>
      [
        QUESTION_TYPE.BREAKER_SCREEN
      ].includes(type),
    [type]
  );

  return (
    <div
      className={classNames(
        "sticky top-0 flex justify-between  py-2.5 px-[15px] shadow-[0px_4px_34px_rgba(0,0,0,0.1)]",
        "sm:static sm:justify-between sm:bg-opacity-0 sm:bg-none sm:px-[30px] sm:py-[20px] sm:shadow-none",
        {
          "bg-[#000]": (isSpeech || isBreaker) && spotlightOrgFlag,
          "bg-seashell": !spotlightOrgFlag,
          "hidden": isMcq && spotlightOrgFlag
        }
      )}
    >
      {/* <h4
        className={classNames(
          "text-sm font-medium text-cocoa-brown",
          "sm:flex sm:flex-1 sm:justify-start sm:text-base"
        )}
      >
        {sectionName}
      </h4> */}
      <h4
        className={classNames(
          // "hidden",
          "sm:right-14 sm:flex sm:flex-1 sm:justify-start sm:text-base sm:font-medium sm:text-cocoa-brown",
          {
            "hidden sm:hidden": (isSpeech || isBreaker) && spotlightOrgFlag
          }
        )}
      >
        {questionOrder}
      </h4>
      {
        (isSpeech || isBreaker)
          ? <div className={classNames("flex flex-col items-start", {
            "hidden": !spotlightOrgFlag
          })}>
            <p className="text-[22px] font-extralight text-[#fff] uppercase">{sectionName}</p>
            <p className="text-[12px] font-extralight text-[#fff] opacity-70 uppercase">{questionOrder.split(" ")[1]} answered</p>
          </div> : <></>
      }
      <div
        className={classNames(
          "align-center flex",
          "sm:flex sm:flex-1 sm:justify-end"
        )}
      >
        {children}
      </div>
    </div>
  );
};
